import React, { useState } from "react";
import ReactDOM from "react-dom";
import { ethers } from "ethers";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Scrollbars } from "react-custom-scrollbars-2";
import "./Modal.scss";
import { useWallet } from "../../../contexts/WalletContext";
import { useAuth } from "../../../contexts/AuthContext";
import { formatPrice } from "../Market/Market";

const Modal = ({
  item,
  onClose,
  tokens,
  ETH,
  onBuy,
  MARKET_ADDRESS,
  MARKET_ABI,
  useFormattedPrice = true,
}) => {
  const {
    ethAddress: walletAddress,
    connectWallet,
    provider,
    isConnecting,
  } = useWallet();
  const { ethAddress: authEthAddress, userEmail } = useAuth();

  const [showWalletModal, setShowWalletModal] = useState(false);
  const [showFullImage, setShowFullImage] = useState(false);

  if (!item) return null;

  const activeAddress = walletAddress || authEthAddress;

  const handleBuy = async (e) => {
    e.stopPropagation();

    if (onBuy) {
      onBuy(item);
      return;
    }

    if (!activeAddress) {
      toast.warn("⚠️ Please connect your wallet first!");
      setShowWalletModal(true);
      return;
    }

    try {
      const web3Provider = new ethers.BrowserProvider(
        provider || window.ethereum,
      );
      const signer = await web3Provider.getSigner();

      const contractAddr = item.marketAddress || MARKET_ADDRESS;
      const contractABI = item.marketABI || MARKET_ABI;
      const contract = new ethers.Contract(contractAddr, contractABI, signer);

      let totalValue;
      let buyId;

      if (item.marketAddress) {
        totalValue = ethers.toBigInt(item.pricePerToken);
        buyId = item.listingId;
      } else {
        totalValue = ethers.parseEther(item.price?.toString() || "0");
        buyId = item.id;
      }

      const balance = await web3Provider.getBalance(activeAddress);
      if (balance < totalValue) {
        toast.error("❌ Not enough ETH to buy this NFT");
        return;
      }

      const tx = await contract.buy(buyId, 1, { value: totalValue });
      await tx.wait();

      toast.success("✅ Purchase successful!");
    } catch (err) {
      console.error("Purchase error:", err);
      toast.error("❌ Purchase failed!");
    }
  };

  const handleConnectWallet = async () => {
    if (walletAddress || isConnecting) return;
    try {
      await connectWallet();
    } finally {
      setShowWalletModal(false);
    }
  };

  return (
    <div className="pre-modal-overlay" onClick={onClose}>
      <div className="pre-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="pre-modal-close" onClick={onClose}>
          × Close
        </button>

        <img
          src={item.prev || item.preview}
          alt={item.name}
          className="pre-modal-img"
          draggable="false"
          onContextMenu={(e) => e.preventDefault()}
          onClick={() => setShowFullImage(true)}
        />

        <div className="pre-modal-right">
          <h2 className="pre-modal-title">{item.name}</h2>
          <p>
            <b>{item.year}</b> | <b>{item.size} size</b>
          </p>
          <div className="info-size-div">
            <p className="pre-modal-price">
              {useFormattedPrice
                ? `${formatPrice(item.price)} ${ETH}`
                : `${item.price} ${ETH}`}
            </p>
            <p className="pre-modal-tokens">
              {item.quantity} {tokens}
            </p>
          </div>

          <div className="pre-modal-desc">
            <Scrollbars autoHide style={{ height: "28vh" }}>
              <p>{item.desc || item.description}</p>
            </Scrollbars>
          </div>

          <button className="buy-btn" onClick={handleBuy}>
            Buy
          </button>
        </div>
      </div>

      {showFullImage &&
        ReactDOM.createPortal(
          <div
            className="full-image-overlay"
            onClick={() => setShowFullImage(false)}
          >
            <div
              className="full-image-container"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="full-image-close"
                onClick={() => setShowFullImage(false)}
              >
                ×
              </button>
              <img
                src={
                  item.metadata?.image ||
                  item.img ||
                  item.image ||
                  item.prevfile
                }
                alt={item.name}
                className="full-image"
              />
            </div>
          </div>,
          document.body,
        )}

      {showWalletModal &&
        ReactDOM.createPortal(
          <div
            className="modal-overlay-global"
            onClick={() => setShowWalletModal(false)}
          >
            <div
              className="modal-box-global"
              onClick={(e) => e.stopPropagation()}
            >
              <h3>Connect Your Wallet</h3>
              <p>You need to connect your wallet to continue.</p>
              <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                <button onClick={handleConnectWallet}>
                  {isConnecting ? "Connecting..." : "Connect Wallet"}
                </button>
                <button onClick={() => setShowWalletModal(false)}>Close</button>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
};

export default Modal;
